<template>
  <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
    <div class="intro-y col-span-12 flex flex-wrap  items-center mt-2">
      <button class="button shadow-md mr-2" @click="filterAll()">
        All
      </button>
      <button
        class="button shadow-md mr-2"
        v-for="d in domains"
        @click="filterDomain(d)"
        :key="d"
      >
        {{ d }}
      </button>
      <button
        class="button shadow-md mr-2"
        v-for="d in subjects"
        @click="filterSubject(d)"
        :key="d"
      >
        {{ d }}
      </button>
      <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
        <div class="w-56 relative text-gray-700 dark:text-gray-300">
          <input
            @input="search"
            type="text"
            v-model="searchData"
            class="input w-56 box pr-10 placeholder-theme-13"
            placeholder="Search..."
          />
          <SearchIcon class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0" />
        </div>
      </div>
    </div>
    <div id="ques-add-modal" class="p-5 float-right">
      <div class="preview">
        <div class="text-center">
          <a
            data-toggle="modal"
            data-target="#quiz-add"
            class="button inline-block bg-theme-1 text-white"
            >+ Add Quiz</a
          >
        </div>
        <div id="quiz-add" class="modal">
          <div class="modal__content">
            <div
              class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5"
            >
              <h2 class="font-medium text-base mr-auto">
                Add Quiz
              </h2>
            </div>
            <div class="intro-y box p-5">
              <div>
                <label>Quiz Title</label>
                <input
                  v-model="model.quiz_title"
                  type="text"
                  class="input w-full border mt-2"
                  placeholder="Enter the name of the quiz"
                />
              </div>
              <div class="mt-3">
                <label>Grade</label>
                <div class="mt-2">
                  <input
                    v-model="model.domain"
                    type="text"
                    class="input w-full border"
                    placeholder="Grade I / Grade II ..."
                    v-if="customDomain"
                  />
                  <div v-else>
                    <TailSelect
                      v-model="model.domain"
                      :options="{
                        hideSelected: true,
                        hideDisabled: true,
                        multiShowCount: false,
                        multiContainer: true,
                        classNames: 'w-full',
                      }"
                      single
                    >
                      <option value="Grade 1">Grade 1</option>
                      <option value="Grade 2">Grade 2</option>
                      <option value="Grade 3">Grade 3</option>
                      <option value="Grade 4">Grade 4</option>
                      <option value="Grade 5">Grade 5</option>
                      <option value="Grade 6">Grade 6</option>
                      <option value="Grade 7">Grade 7</option>
                      <option value="Grade 8">Grade 8</option>
                      <option value="Grade 9">Grade 9</option>
                      <option value="Grade 10">Grade 10</option>
                      <option value="Grade 11">Grade 11</option>
                      <option value="Grade 12">Grade 12</option>
                    </TailSelect>
                  </div>
                  <div class="pl-2 py-2">
                    Custom <input type="checkbox" v-model="customDomain" />
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <label>Subject</label>
                <div class="mt-2">
                  <input
                    v-model="model.quiz_subject"
                    type="text"
                    class="input w-full border"
                    placeholder="Coding / Soft Skills / English Learning ..."
                    v-if="customSubject"
                  />
                  <div v-else>
                    <TailSelect
                      v-model="model.quiz_subject"
                      :options="{
                        hideSelected: true,
                        hideDisabled: true,
                        multiShowCount: false,
                        multiContainer: true,
                        classNames: 'w-full',
                      }"
                      single
                    >
                      <option value="Math">Math</option>
                      <option value="Science">Science</option>
                      <option value="English Learning">English Learning</option>
                      <option value="Coding">Coding</option>
                      <option value="Debate">Debate</option>
                      <option value="Presentation">Presentation</option>
                      <option value="GK">GK</option>
                      <option value="Robotics">Robotics</option>
                      <option value="ICT">ICT</option>
                      <option value="Data Science">Data Science</option>
                      <option value="UIUX">UIUX</option>
                      <option value="FrontEnd">FrontEnd</option>
                      <option value="Hiring">Hiring</option>
                      <option value="Test">Test</option>
                      <option value="Other">Other</option>
                    </TailSelect>
                  </div>
                  <div class="pl-2 py-2">
                    Custom <input type="checkbox" v-model="customSubject" />
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <label>Difficulty</label>
                <div class="mt-2">
                  <TailSelect
                    v-model="model.difficulty"
                    :options="{
                      hideSelected: true,
                      hideDisabled: true,
                      multiShowCount: false,
                      multiContainer: true,
                      classNames: 'w-full',
                    }"
                    single
                  >
                    <option value="Easy">Easy</option>
                    <option value="Medium">Medium</option>
                    <option value="Hard">Hard</option>
                  </TailSelect>
                </div>
              </div>
              <div class="mt-3">
                <label>Time Required</label>
                <div class="relative mt-2">
                  <input
                    v-model="model.time_required"
                    type="text"
                    class="input w-full border"
                    placeholder="Time"
                  />
                  <div
                    class="absolute top-0 right-0 rounded-r h-full flex items-center justify-center bg-gray-100 dark:border-dark-4 border text-gray-600"
                  >
                    <TailSelect v-model="unit" single>
                      <option value="s">Second(s)</option>
                      <option value="m">Minute(s)</option>
                      <option value="h">Hour(s)</option>
                    </TailSelect>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <label>Image</label>
                <div class="mt-2">
                  <TailSelect
                    v-model="model.Other.card_image"
                    :options="{
                      hideSelected: true,
                      hideDisabled: true,
                      multiShowCount: false,
                      multiContainer: true,
                      classNames: 'w-full',
                    }"
                    single
                  >
                    <option v-for="(o, i) in cardImages" :value="o" :key="o"
                      >Image {{ i + 1 }}</option
                    >
                  </TailSelect>
                </div>
                <img
                  :src="model.Other.card_image"
                  v-if="model.Other.card_image"
                />
              </div>
              <div class="mt-3">
                <label>Usage Metric</label>
                <div class="mt-2">
                  <input
                    v-model="model.Other.usage_metric"
                    type="text"
                    class="input w-full border"
                    placeholder="OPS/Social media/..."
                    v-if="customUsage"
                  />
                  <div v-else>
                    <TailSelect
                      v-model="model.Other.usage_metric"
                      :options="{
                        hideSelected: true,
                        hideDisabled: true,
                        multiShowCount: false,
                        multiContainer: true,
                        classNames: 'w-full',
                      }"
                      single
                    >
                      <option value="OPS">OPS</option>
                      <option value="Social Media">Social Media</option>
                      <option value="Organic">Organic</option>
                      <option value="Competition">Competition</option>
                    </TailSelect>
                  </div>
                  <div class="pl-2 py-2">
                    Custom <input type="checkbox" v-model="customUsage" />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="px-5 py-3 text-right border-t border-gray-200 dark:border-dark-5"
            >
              <Button
                type="button"
                data-dismiss="modal"
                class="button w-20 border text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1"
              >
                Cancel
              </Button>
              <Button
                type="button"
                class="button w-20 bg-theme-1 text-white"
                @click="addQuiz()"
              >
                Add
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="assign-add-modal" class="p-5 float-right">
      <div class="preview">
        <div class="text-center">
          <a
            data-toggle="modal"
            data-target="#assign-add"
            class="button inline-block bg-theme-1 text-white"
            >+ Add Assignment</a
          >
        </div>
        <div id="assign-add" class="modal">
          <div class="modal__content">
            <div
              class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5"
            >
              <h2 class="font-medium text-base mr-auto">
                Add Assignment
              </h2>
            </div>
            <div class="intro-y box p-5">
              <div>
                <label>Assignment Title</label>
                <input
                  v-model="model.quiz_title"
                  type="text"
                  class="input w-full border mt-2"
                  placeholder="Enter the name of the quiz"
                />
              </div>
              <div class="mt-3">
                <label>Grade</label>
                <div class="mt-2">
                  <input
                    v-model="model.domain"
                    type="text"
                    class="input w-full border"
                    placeholder="Grade I / Grade II ..."
                  />
                  <!--                  <TailSelect-->
                  <!--                      v-model="model.domain"-->
                  <!--                      :options="{-->
                  <!--                      hideSelected: true,-->
                  <!--                      hideDisabled: true,-->
                  <!--                      multiShowCount: false,-->
                  <!--                      multiContainer: true,-->
                  <!--                      classNames: 'w-full'-->
                  <!--                    }"-->
                  <!--                      single-->
                  <!--                  >-->
                  <!--                    <option value="Grade 1">Grade 1</option>-->
                  <!--                    <option value="Grade 2">Grade 2</option>-->
                  <!--                    <option value="Grade 3">Grade 3</option>-->
                  <!--                    <option value="Grade 4">Grade 4</option>-->
                  <!--                    <option value="Grade 5">Grade 5</option>-->
                  <!--                  </TailSelect>-->
                </div>
              </div>
              <div class="mt-3">
                <label>Subject</label>
                <div class="mt-2">
                  <input
                    v-model="model.quiz_subject"
                    type="text"
                    class="input w-full border"
                    placeholder="Coding / Soft Skills / English Learning ..."
                  />
                  <!--                  <TailSelect-->
                  <!--                      v-model="model.quiz_subject"-->
                  <!--                      :options="{-->
                  <!--                      hideSelected: true,-->
                  <!--                      hideDisabled: true,-->
                  <!--                      multiShowCount: false,-->
                  <!--                      multiContainer: true,-->
                  <!--                      classNames: 'w-full'-->
                  <!--                    }"-->
                  <!--                      single-->
                  <!--                  >-->
                  <!--                    <option value="Math">Math</option>-->
                  <!--                    <option value="Science">Science</option>-->
                  <!--                    <option value="Coding">Coding</option>-->
                  <!--                    <option value="Soft Skills">Soft Skills</option>-->
                  <!--                    <option value="English Learning">English Learning</option>-->
                  <!--                    <option value="Debate">Debate</option>-->
                  <!--                    <option value="Other">Other</option>-->
                  <!--                  </TailSelect>-->
                </div>
              </div>
              <div class="mt-3">
                <label>Difficulty</label>
                <div class="mt-2">
                  <TailSelect
                    v-model="model.difficulty"
                    :options="{
                      hideSelected: true,
                      hideDisabled: true,
                      multiShowCount: false,
                      multiContainer: true,
                      classNames: 'w-full',
                    }"
                    single
                  >
                    <option value="Easy">Easy</option>
                    <option value="Medium">Medium</option>
                    <option value="Hard">Hard</option>
                  </TailSelect>
                </div>
              </div>
              <div class="mt-3">
                <label>Deadline</label>
                <div class="relative mt-2">
                  <input
                    v-model="model.Other.ends_at"
                    type="datetime-local"
                    class="input w-full border"
                    placeholder="Time"
                  />
                </div>
              </div>
            </div>
            <div
              class="px-5 py-3 text-right border-t border-gray-200 dark:border-dark-5"
            >
              <Button
                type="button"
                data-dismiss="modal"
                class="button w-20 border text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1"
              >
                Cancel
              </Button>
              <Button
                type="button"
                class="button w-20 bg-theme-1 text-white"
                @click="addAssignment()"
              >
                Add
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <table class="table table-report -mt-2">
      <thead>
        <tr>
          <th
            v-for="h in headers"
            :key="h"
            class="text-center whitespace-no-wrap"
          >
            {{ h }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="q in items" :key="q.id" class="intro-x">
          <td>
            <div class="font-medium ">{{ q.quiz_title }}</div>
          </td>
          <td>
            <div class="text-center">
              {{ q.quiz_subject }}
            </div>
          </td>
          <td>
            <div class="text-center">{{ parseTime(q.created_at) }}</div>
            <div class="text-center text-small text-gray-700">
              {{ relativeTime(q.created_at) }}
            </div>
          </td>
          <td class="text-center">{{ q.time_required }}</td>
          <td class="table-report__action ">
            <div class="flex justify-center items-center">
              <button
                class="flex items-center mr-3"
                @click="goToQuestions(q.quiz_id)"
              >
                <CheckSquareIcon class="w-4 h-4 mr-1" />
                Edit
              </button>
              <a
                class="flex items-center text-theme-6 cursor-pointer"
                data-toggle="modal"
                data-target="#delete-confirmation-modal"
                @click="deleteQuiz(q)"
              >
                <Trash2Icon class="w-4 h-4 mr-1" /> Delete
              </a>
              <button
                class="flex items-center ml-3"
                @click="goToLeaderboard(q.quiz_id)"
              >
                <ShieldIcon class="w-4 h-4 mr-1" />
                Leaderboard
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import Uploader from "./Uploader";
import moment from 'moment'
export default {
  name: 'UTableVue',
  components: {
    // Button
    // Uploader
  },
  data() {
    return {
      absoluteData: [],
      analytics: {},
      headers: ['Quiz Title', 'Subject', 'Created At', 'Time Required', ''],
      headers2: [
        'Quiz Title',
        'Subject',
        'Domain',
        'Submissions',
        'Average Score',
      ],
      model: {
        quiz_title: '',
        quiz_subject: '',
        time_required: '',
        difficulty: 'Easy',
        status: '',
        Other: {
          ends_at: '',
          card_image:
            'https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Coding+(2).jpg',
        },
      },
      cardImages: [
        'https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Coding+(2).jpg',
        'https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Coding.jpg',
        'https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/English.jpg',
        'https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Math-2.jpg',
        'https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Math.jpg',
        'https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Robotics-2.jpg',
        'https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Robotics.jpg',
        'https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/soft-skill.jpg',
        'https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Stem.jpg',
      ],
      unit: 's',
      items: [],
      customDomain: true,
      customSubject: false,
      customCategory: false,
      customUsage: false,
      isModal: true,
      domains: [],
      subject: [],
      searchData: '',
    }
  },
  created() {
    this.getQuizzes()
  },
  watch: {
    $route(to, from) {
      console.log(to, from)
    },
  },
  methods: {
    filterAll(d) {
      this.items = [...this.absoluteData]
    },
    filterDomain(d) {
      this.items = this.absoluteData.filter((o) => o.domain.includes(d))
    },
    filterSubject(d) {
      this.items = this.absoluteData.filter((o) => o.quiz_subject.includes(d))
    },
    search() {
      if (this.searchData.length > 1) {
        this.items = this.absoluteData.filter((o) =>
          o.quiz_title.toLowerCase().includes(this.searchData.toLowerCase())
        )
      } else {
        this.items = [...this.absoluteData]
      }
    },
    deleteQuiz(q) {
      this.$dialog
        .confirm('Are you sure, you want to delete the quiz?')
        .then(() => {
          this.$upskill.orgDeleteQuizByID(q.quiz_id).then(() => {
            this.getQuizzes()
          })
        })
        .catch(() => {})
    },
    goToQuestions(quiz_id) {
      this.$router.push({ name: 'questions', params: { quiz_id } })
    },
    goToLeaderboard(quiz_id) {
      this.$router.push({ name: 'leaderboard-quiz', params: { quiz_id } })
    },
    parseTime(t) {
      return moment(t).format('lll')
    },
    relativeTime(t) {
      return moment(t).fromNow()
    },
    closeAllModals() {
      const modals = document.getElementsByClassName('modal')
      for (let i = 0; i < modals.length; i++) {
        modals[i].classList.remove('show')
      }
    },
    getQuizzes() {
      this.$upskill.orgGetQuizzes('upskill').then((res) => {
        this.items = res.data.data

        this.absoluteData = [...res.data.data]
        let domainSet = new Set()
        let subjectSet = new Set()
        this.absoluteData.forEach((o) => {
          o.domain.length > 0 ? domainSet.add(o.domain) : ''
          o.quiz_subject.length > 0 ? subjectSet.add(o.quiz_subject) : ''
        })
        this.domains = Array.from(domainSet)
        this.subjects = Array.from(subjectSet)

        this.items.sort((a, b) =>
          a.quiz_title
            .toLowerCase()[0]
            .localCompare(b.quiz_title.toLowerCase()[0])
        )
      })
    },
    addQuiz() {
      this.model.org_id = 'upskill'
      this.model.status = 'active'
      if (this.model.Other && this.model.Other.ends_at) {
        delete this.models.Other['ends_at']
      }
      if (this.unit == '') {
        alert('Select a unit!')
        return
      }
      this.model.time_required = parseInt(this.model.time_required)
      this.model.time_required += this.unit
      this.$upskill.orgAddQuiz(this.model).then(() => {
        this.getQuizzes()
        this.closeAllModals()
        this.model = {
          quiz_title: '',
          quiz_subject: '',
          time_required: '',
          difficulty: 'Easy',
          status: '',
          Other: {
            ends_at: '',
            card_image:
              'https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Coding+(2).jpg',
          },
        }
      })
    },
    addAssignment() {
      this.model.org_id = 'upskill'
      this.model.status = 'active'
      let newDate = new Date(this.model.Other.ends_at)
      this.model.Other.ends_at = newDate.toISOString()

      this.model.time_required = ''
      this.$upskill.orgAddQuiz(this.model).then(() => {
        this.getQuizzes()
        this.closeAllModals()
        this.model = {
          quiz_title: '',
          quiz_subject: '',
          time_required: '',
          difficulty: 'Easy',
          status: '',
          Other: {
            ends_at: '',
            card_image:
              'https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Coding+(2).jpg',
          },
        }
      })
    },
  },
}
</script>

<style scoped></style>
